import React, { useEffect, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "../../Style/Dashboard.css";

import DashboardLayoutStatistics from "./DashboardLayoutStatistics";
import DashboardLayoutQuickLinks from "./DashboardLayoutQuickLinks";

import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { useHistory } from "react-router-dom";


const UserDashboard = () => {
  const { t: translator } = useTranslation();
  const history = useHistory();
  const {
    updateLocTab,
    updateLocTenant,
    updateLocName,
    updateLocUser,
    updateLocStore,
    updateLocPos,
  } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const [tab, setTab] = useState("statistics");
  const [isAuth, setIsAuth] = useState(true);

  useEffect(() => {
   

    if (![master, admin, support].includes(Number(roleId)))
      history.push("/dashboard");

    updateLocTab(0);
    updateLocTenant(0);
    updateLocUser(0);
    updateLocName("dashboard");
    updateLocStore(0);
    updateLocPos(0);
  }, []);

  const handleSelect = (tabId) => {
    setTab(tabId);
  };

  return (
    <>
      {isAuth && (
       <>
        <DashboardLayoutQuickLinks />
        <DashboardLayoutStatistics />
       </>
      )}
    </>
  );
};

export default UserDashboard;
